import Vue from 'vue'
import VueGtag from "vue-gtag";
import AppSplash from './AppSplash.vue'
import App from './App.vue'
import AppNoConnection from './AppNoConnection.vue'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  render: h => h(AppSplash)
}).$mount('#splash')

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue } from 'bootstrap-vue'
import './core/Styles/main.styl'
import { UtilsI18n, Zoom } from './core/Utils'

import router from './router'
import store from './store'

if (process.env.VUE_APP_GA_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GA_ID }
  }, router)
}

Vue.use(BootstrapVue)

Zoom.initZoom()

UtilsI18n.initI18n().then(function(i18n) {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}).catch(function (e) {
  console.log(e)
  new Vue({
    render: h => h(AppNoConnection)
  }).$mount('#app')
})
